/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-12-19 15:32:50
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-04-09 11:47:32
 * @FilePath: /work.xhey.top/src/pages/photov2/utils/track.ts
 */
import sensors, { sensorsRole } from '../../../utils/sensors'
import { store } from '../../../app/store'
import type { RootState } from '../../../app/store'
import { applyPicPageClickSupplementFields } from './picPageClickEnhancements'

const TRACK_SIGN = 'aworkgroup.b4343.action.web_workgroup_picspage_click'
const DEFAULT_REQUIREMENT_ID = 108

const getGroupInfo = () => {
  const state = store.getState()
  const groupID = state?.group?.groupId || ''
  const roleNum = state?.group?.myRole || 0
  const role = sensorsRole(roleNum)
  return { groupID, role }
}

export const trackPicsPageClickV2 = (params: {
  clickItem: string
  requirement_id?: number
  isOpenErrorCorrection?: boolean
  [key: string]: any
}) => {
  const { clickItem, requirement_id = DEFAULT_REQUIREMENT_ID, ...rest } = params
  const { groupID, role } = getGroupInfo()

  const trackParams: Record<string, any> = {
    clickItem,
    groupID,
    role,
    track_sign: TRACK_SIGN,
    requirement_id,
    ...rest
  }

  if (Object.prototype.hasOwnProperty.call(params, 'isOpenErrorCorrection')) {
    trackParams.isOpenErrorCorrection = rest.isOpenErrorCorrection
  }

  applyPicPageClickSupplementFields(
    trackParams,
    store.getState() as RootState,
    clickItem
  )

  sensors.track('web_workgroup_picspage_click', trackParams)
}

/** Toast：原始筛选结果与推荐结果不可同时选中（20260414 clickItem） */
export const trackMutualExclusiveSelectionToast = () => {
  trackPicsPageClickV2({ clickItem: '出现不可同时选中toast' })
}
